/**
 * Mirrors bill/invoice auto-assignment rules in SyncController::syncChartOfAccounts.
 * Shown as informational copy after a successful chart-of-accounts sync.
 */
export type GlSyncBillInvoiceRule = {
  id: string;
  flagLabel: "Bills only" | "Bills" | "Invoices only";
  description: string;
};

export const GL_SYNC_BILL_INVOICE_RULES: GlSyncBillInvoiceRule[] = [
  {
    id: "expense-types",
    flagLabel: "Bills only",
    description:
      "Account types: Expense, Cost Of Goods Sold, Fixed Asset",
  },
  {
    id: "other-current-asset-patterns",
    flagLabel: "Bills",
    description:
      "Account type: Other Current Asset (when GL name contains Input, TDS, TCS, Prepaid, Advance, Deposit, or Reverse Charge)",
  },
  {
    id: "other-current-liability-tds",
    flagLabel: "Bills",
    description:
      "Account type: Other Current Liability (when GL name contains TDS Payable)",
  },
  {
    id: "income-types",
    flagLabel: "Invoices only",
    description: "Account types: Income, Other Income",
  },
];

export const GL_SYNC_BILL_INVOICE_RULES_FAILED_MESSAGE =
  "Bill/invoice auto-assignment may not have completed. Check error details above.";

export function chartOfAccountsSyncHadBillInvoiceRuleFailure(
  errorDetails: string[] | undefined,
): boolean {
  if (!errorDetails?.length) {
    return false;
  }
  return errorDetails.some((error) =>
    error.includes("Failed to apply business rules"),
  );
}
